export const TASKS_RESET_STATE = 'TASKS_RESET_STATE';
export const TASKS_CURRENT_ITEM = 'TASKS_CURRENT_ITEM';

export const TASKS_REQUEST_LOADING = 'TASKS_REQUEST_LOADING';
export const TASKS_REQUEST_SUCCESS = 'TASKS_REQUEST_SUCCESS';
export const TASKS_REQUEST_FAILED = 'TASKS_REQUEST_FAILED';

export const TASKS_CURRENT_ACTION = 'TASKS_CURRENT_ACTION';
export const TASKS_RESET_ACTION = 'TASKS_RESET_ACTION';